import {usePermissions} from './PermissionProvider';
import {checkIfAuthorized} from './api';
import {Navigate} from 'react-router-dom';

interface SecuredRouteProps {
    children: JSX.Element;
    requiredPermissions: string[];
    internal?: boolean;
    redirect?: string;
}

const SecuredRoute = ({
    children,
    requiredPermissions,
    internal,
    redirect,
}: SecuredRouteProps): JSX.Element | null => {
    const userPermissions = usePermissions();

    const isAuthorized = checkIfAuthorized(userPermissions, requiredPermissions);

    if (isAuthorized) {
        return children;
    }

    return (
        <Navigate
            to={redirect ? redirect : internal ? '/error/404' : '/error/401'}
            replace={true}
        />
    );
};

export default SecuredRoute;
